import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import axios from 'axios';

import type { OlderLiveClass } from '../../interfaces/older-live-class';

export default abstract class TeacherLiveClassDao {
  static async getOlderLiveClasses(env: Environment, teacherId: number) {
    const url = hostsConfig[env].liveclassServiceUrl;

    const { data } = await axios.get<OlderLiveClass[] | undefined>(
      `${url}/v1/monitor/olderclasses/${teacherId}`
    );
    return data;
  }

  static async sendGroupLiveClassFeedback(
    env: Environment,
    studentId: number,
    classroomId: number,
    teacherFeedback: string,
    teacherId: number
  ) {
    const url = hostsConfig[env].courseServiceHost;

    const { data } = await axios.post<void>(`${url}/v1/liveclassfeedbacks`, {
      teacherId,
      studentId,
      classroomId,
      teacherFeedback,
    });

    return data;
  }
}
